import { EventEmitter, Input, Output } from '@angular/core';
import { CardModel } from '../../../../../../shared/models/payment/card.model';
import { FormGroup } from '@angular/forms';
import { PaymentMethodModel } from '../../../../../../shared/models/payment-method.model';
import { PaymentGatewayModel } from '../../../../../../shared/models/payment-gateway.model';

export class PaymentPaymentOptionCardFormAbstractForm {
    @Input('index') index: number;
    @Input('cardIndex') cardIndex: number;
    @Input('form') form: FormGroup;
    @Input('paymentMethod') paymentMethod: PaymentMethodModel;
    @Input('paymentGateway') paymentGateway: PaymentGatewayModel;
    @Output('ready') ready: EventEmitter<CardModel> = new EventEmitter<CardModel>();
    @Output('pending') pending: EventEmitter<null> = new EventEmitter<null>();

    public validate() {
        if (this.form.valid) {
            this.ready.emit(this.form.getRawValue());
        } else {
            this.pending.emit();
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/payment/payment/option/card/option/form/payment.payment.option.card.form.abstract-form.ts